import React from "react";

const cursos = [
	{
		title: "Uso Seguro de Motosserras ",
		description: "Treinamento completo com foco na NR-12 e ergonomia.",
		images: [
			"/images/pericias/safetymoto3.jpg",
			"/images/pericias/safetymoto2.jpg",
			"/images/pericias/safetymoto1.jpg",
		],
	},
	{
		title: "Operação Segura de Roçadeiras",
		description: "Técnicas corretas e seguras para uso de roçadeiras.",
		images: [
			"/images/bateria/rocadeira1.jpg",
			"/images/bateria/rocadeira2.jpg",
			"/images/bateria/rocadeira3.jpg",
		],
	},
	{
		title: "Utilização Segura de máquinas e ferramentas",
		description: "Prevenção de lesões através de técnicas ergonômicas.",
		images: [
			"/images/trex1.jpeg",
			"/images/trex2.jpeg",
			"/images/trex3.jpeg",
		],
	},
];

const normas = [
	
	{
		title: "NR-06 - Equipamentos de Proteção Individual",
		description: "Uso correto e manutenção de EPIs.",
		images: [
			"/images/pericias/epi01.jpg",
			"/images/pericias/epi02.jpg",
			"/images/pericias/epi03.jpg",
		],
	},
	{
		title: "NR-17 - Trabalho com Ergonomia",
		description: "Ergonomia e a longevidade profissional.",
		images: [
			"/images/bateria/rocadeira5.jpg",
			"/images/usebat1.jpeg",
			"/images/bateria/rocadeira4.jpg",
		],
	},
];

const Section = ({ title, description, images }) => (
	<section className="py-12 bg-white animate-fade-in">
		<div className="container mx-auto px-4">
			<h2 className="text-3xl font-bold text-husqvarna-orange mb-4 text-center">
				{title}
			</h2>
			<p className="text-lg text-husqvarna-dark-gray/80 mb-8 text-center">
				{description}
			</p>
			<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
				{images.map((src, idx) => (
					<div
						key={idx}
						className="overflow-hidden rounded-xl shadow-lg bg-husqvarna-light-gray flex items-center justify-center aspect-[4/3] transition-transform duration-300 hover:scale-105"
						style={{ minHeight: 0 }}
						tabIndex={0}
					>
						<img
							src={src}
							alt={`${title} ${idx + 1}`}
							className="object-cover w-full h-full"
							style={{
								maxHeight: "220px",
								width: "100%",
								transition: "transform 0.3s",
							}}
							loading="lazy"
							onError={(e) => {
								e.target.src =
									"https://via.placeholder.com/400x300?text=Imagem+Indisponível";
							}}
						/>
					</div>
				))}
			</div>
		</div>
	</section>
);

const Treinamento = () => (
	<>
		<div className="min-h-screen bg-gray-100 font-inter animate-fade-in">
			<header className="bg-husqvarna-dark-gray text-husqvarna-white py-8 text-center shadow-lg">
				<h1 className="text-4xl md:text-5xl font-bold">
					Cursos e Treinamentos
				</h1>
				<p className="text-lg mt-2 text-husqvarna-light-gray">
					Capacitação, segurança e ergonomia para profissionais Husqvarna
				</p>
			</header>
			{/* Sessão 1: Cursos */}
			{cursos.map((curso, idx) => (
				<Section key={idx} {...curso} />
			))}
			{/* Sessão 2: Normas */}
			{normas.map((norma, idx) => (
				<Section key={idx} {...norma} />
			))}
		</div>
		<style>
			{`
        .animate-fade-in {
          animation: fadeIn 1s ease;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px);}
          to { opacity: 1; transform: translateY(0);}
        }
      `}
		</style>
	</>
);

export default Treinamento;
